@if (loading) {
  <div class="spinner-container">
    <div class="spinner"></div>
  </div>
}


<div class="filter-row">
    <!-- Event Name Dropdown -->
    <mat-form-field appearance="outline" class="event-name-field">
      <mat-label>Event Name</mat-label>
      <input matInput [(ngModel)]="name" (keyup.enter)="applySave()">
    </mat-form-field>

    <mat-form-field appearance="outline" class="friendly-field">
      <mat-label>Friendly Name</mat-label>
      <input matInput [(ngModel)]="friendlyName" (keyup.enter)="applySave()">
    </mat-form-field>

    <mat-form-field appearance="outline" class="remark-field">
      <mat-label>Remark</mat-label>
      <input matInput [(ngModel)]="remark" (keyup.enter)="applySave()">
    </mat-form-field>

    <!-- Producers -->
     <mat-form-field appearance="outline" class="target-field">
       <mat-label>Producers</mat-label>        
        <mat-select multiple [(value)]="selectedProducers">
          <mat-option [value]="null">-</mat-option>
          @for (source of sourceSystems; track source) {
            <mat-option [value]="source.Id">
              {{ source.Name }} - {{ source.FriendlyName }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

    <!-- Consumers -->
     <mat-form-field appearance="outline" class="target-field">
       <mat-label>Consumers</mat-label>        
        <mat-select multiple [(value)]="selectedConsumers">
          <mat-option [value]="null">-</mat-option>
          @for (target of targetSystems; track target) {
            <mat-option [value]="target.Id">
              {{ target.Name }} - {{ target.FriendlyName }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

    <div class="button-row">
      <button
      mat-flat-button
      color="primary"
      (click)="applySave()"
      [disabled]="!name && !friendlyName">
      Save
    </button>
    <button mat-flat-button (click)="clearFilters()">Clear</button>
    </div>
  </div>